export default "__VITE_ASSET__0s8FIxv9__"